import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { createPortal } from 'react-dom'

const ConfirmationModal = ({
    onConfirm = () => {},
    onCancel = () => {},
    visible,
    children,
    title = 'Are you sure?',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    disableConfirm
}) => {

    return visible ? createPortal(
        <Modal show={visible} onHide={onCancel} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            {Boolean(children) && <Modal.Body>{children}</Modal.Body>}
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>{cancelLabel}</Button>
                <Button variant="primary" onClick={onConfirm} disabled={disableConfirm}>{confirmLabel}</Button>
            </Modal.Footer>
        </Modal>
        , document.body) : null
}

export default ConfirmationModal